/* eslint-disable jsx-a11y/anchor-is-valid */
import { Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import helper from "../helper/helper";
import { entityService } from "../module/private/shared/service/entity.service";
import { EntityOption } from "../module/private/shared/shared.model";
import { RouteContext } from "../module/private/user/screen/components/route.context";
import { routeActions } from "../module/private/user/service/route.reducer";
import { userService } from "../module/private/user/service/user.service";
import { authService } from "../module/public/auth/service/auth.service";

const { Option } = Select;

function NavBar() {
  const [routes, setRoutes] = useState<EntityOption[]>([]);
  const user = helper.getUser();

  const { state, dispatch } = useContext(RouteContext);

  useEffect(() => {
    if (user?.sub) {
      console.table(user);
      userService.getUser(user.sub).then((_user) => {
        userService.getUserGroup(user?.sub).then((group) => {
          entityService.getRoutes().then((_routes) => {
            let routes = [];
            console.log(group);

            if (helper.isRouteRule(group)) {
              routes = _routes.filter((x) =>
                _user.attributes.routes?.includes(x.value)
              );
            } else {
              routes = _routes;
            }

            if (routes.length > 0) {
              onRouteSelect(routes[0].value);
            }

            setRoutes(routes);
          });
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRouteSelect = (value: string) => {
    dispatch({ type: routeActions.SET_ROUTE, routeId: value });
  };

  return (
    <div className="navbar navbar-expand-md navbar-light">
      <div className="navbar-brand">
        <Link to="/users" className="d-inline-block">
          <img src="/assets/images/Logo.svg" alt="" />
        </Link>
      </div>
      <div className="d-md-none">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-mobile"
        >
          <i className="icon-tree5" />
        </button>
        <button
          className="navbar-toggler sidebar-mobile-main-toggle"
          type="button"
        >
          <i className="icon-paragraph-justify3" />
        </button>
      </div>
      <div className="collapse navbar-collapse" id="navbar-mobile">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">
              <i className="icon-paragraph-justify3" />
            </a>
          </li>
        </ul>
        <span className="ml-md-3 mr-md-auto">
          <div></div>
        </span>
        <Select
          style={{
            width: "200px",
          }}
          value={state.routeId}
          onChange={onRouteSelect}
        >
          {routes.map((x) => (
            <Option key={x.id} value={x.value}>
              {x.label}
            </Option>
          ))}
        </Select>
        <ul className="navbar-nav">
          <li className="nav-item dropdown dropdown-user">
            <a
              className="navbar-nav-link d-flex align-items-center dropdown-toggle"
              data-toggle="dropdown"
            >
              <img
                src="/assets/limitless/global_assets/images/placeholders/placeholder.jpg"
                className="rounded-circle mr-2"
                height={34}
                alt=""
              />
              <span>{helper.getUserFullName(user)}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a className="dropdown-item" onClick={() => authService.logout()}>
                <i className="icon-switch2" /> Гарах
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NavBar;
